import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3044a3d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "back",
  style: {"padding":"0 12px 0 16px"},
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 조합 가입확인서 서명 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 조합 가입확인서 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 성명 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 생년월일 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 위 구매자(양수인)은 아래와 같이 판매자(양도인)로부터 판매자가 보유한 조합원 자격을 구매하였습니다. 본인은 이 조합 가입확인서에 기명날인 또는 서명(또는 본인 인증 계정으로 이름 입력)함으로써 조합의 기존 조합원들이 이미 체결한 규약의 당사자가 되고, 매매의 대상이 된 출자지분에 관하여 그 규약에 정해져 있는 판매자가 조합원으로서 가지는 모든 권리와 의무 및 책임을 포괄하여 승계하는 데 동의합니다. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 가입할 조합의 규약 확인 완료 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 가입할 조합의 규약 전문 보기(필수) ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 조합명 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 판매자 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" (엔젤리그 거래ID) ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 구매자 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 매매대상")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 조합원 자격")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" (좌수) ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 좌")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" * 총 매매대금 : ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 확인 날짜 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 구매자 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 본인 서명을 해주세요 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 다시 그리기 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 확인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ag_signature_pad = _resolveComponent("ag-signature-pad")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "align-items": "center",
          p: "3px 0px 20px 0px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              class: "ion-activatable ripple-parent",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_text, {
              typography: "tit18b",
              color: "black"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, null, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, { m: "32px 20px" }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box, { "justify-content": "space-between" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, { typography: "tit24b" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_box, {
                          width: "212px",
                          "margin-top": "32px",
                          dp: "flex",
                          "justify-content": "space-between"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text, {
                              typography: "main16r",
                              color: "gray3"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ag_text, { typography: "main16r" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.purchaseInfo.buyerName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_box, {
                          "margin-top": "8px",
                          width: "212px",
                          dp: "flex",
                          "justify-content": "space-between"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text, {
                              typography: "main16r",
                              color: "gray3"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ag_text, { typography: "main16r" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.splitDate(_ctx.purchaseInfo.buyerBirthDate)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_img, {
                      style: {"flex-shrink":"0"},
                      width: "90px",
                      height: "90px",
                      src: _ctx.purchaseInfo.partnershipLogo
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text, {
                  "margin-top": "32px",
                  dp: "block",
                  typography: "mainL16r"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_ag_box, {
                  style: {"border-top":"1px solid #F9F9FB","border-bottom":"1px solid #F9F9FB"},
                  my: "32px",
                  py: "10px",
                  "justify-content": "space-between",
                  dp: "flex",
                  onClick: _ctx.viewContract
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      typography: "tit18b",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_toggle_icon, {
                      name: "check",
                      value: true
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]), [
                  [_vShow, _ctx.readContract]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_ag_box, {
              my: "32px",
              p: "11px 20px",
              "justify-content": "space-between",
              dp: "flex",
              bg: "red2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합 가입확인서', 'clickContent':`가입할 조합의 규약 전문 보기(필수)`});_ctx.viewContract()})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_text, {
                  typography: "tit18b",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_icon, {
                  style: {"width":"40px","height":"20px","margin-top":"3px"},
                  class: "white ion-float-end",
                  icon: _ctx.chevronForwardOutline
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_ctx.readContract]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          bg: "bg1",
          p: "8px 20px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              dp: "flex",
              direction: "column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  py: "16px",
                  dp: "flex",
                  width: "100%",
                  style: {"border-bottom":"1px solid #D9DEE8"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      dp: "block",
                      width: "90px",
                      "margin-right": "24px",
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "tit16b" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.purchaseInfo.partnershipName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  py: "16px",
                  dp: "flex",
                  width: "100%",
                  style: {"border-bottom":"1px solid #D9DEE8"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      dp: "block",
                      width: "90px",
                      "margin-right": "24px",
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.purchaseInfo.sellerPublicId) + " ", 1),
                        _createVNode(_component_ag_text, {
                          color: "gray2",
                          typography: "main16r"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  py: "16px",
                  dp: "flex",
                  width: "100%",
                  style: {"border-bottom":"1px solid #D9DEE8"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      dp: "block",
                      width: "90px",
                      "margin-right": "24px",
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.splitDate(_ctx.purchaseInfo.buyerBirthDate)) + " " + _toDisplayString(_ctx.purchaseInfo.buyerName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  py: "16px",
                  dp: "flex",
                  width: "100%"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      dp: "block",
                      "min-width": "90px",
                      "margin-right": "24px",
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _hoisted_14,
                        _hoisted_15,
                        _hoisted_16,
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currency(_ctx.purchaseInfo.asset)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _createVNode(_component_ag_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currency(_ctx.purchaseInfo.totalPrice)), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_21,
                        _hoisted_22,
                        _createTextVNode(" * 출자지분에 해당하는 조합 보유 주식 수 : " + _toDisplayString(_ctx.purchaseInfo.stockItemName) + " " + _toDisplayString(_ctx.purchaseInfo.qty) + " 주 ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, { m: "32px 20px 0px 20px" }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, { dp: "block" }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box, {
                  dp: "flex",
                  "justify-content": "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, { typography: "main16r" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.purchaseInfo.currentDate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, {
                  "margin-top": "24px",
                  dp: "flex",
                  "justify-content": "flex-start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      typography: "main16r",
                      color: "gray3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createVNode(_component_ag_text, {
                          "margin-left": "5px",
                          typography: "main14r",
                          color: _ctx.typoColor
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.typoStatus), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.BuyerName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.BuyerName) = $event)),
                  class: "detail_input",
                  type: "text",
                  placeholder: "본인 이름을 입력해주세요"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ag_box, {
                  style: {"position":"relative"},
                  height: "180px",
                  "padding-top": "16px",
                  width: "336px",
                  margin: "0 auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box, {
                      position: "absolute",
                      opacity: _ctx.padClick ? 0 : 1,
                      bg: "bg1",
                      "border-radius": "4px",
                      border: "1px solid #D9DEE8",
                      height: "160px",
                      width: "336px",
                      dp: "flex",
                      "justify-content": "center",
                      "align-items": "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text, {
                          typography: "tit22r",
                          color: "red2"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["opacity"]),
                    (_ctx.padToggle)
                      ? (_openBlock(), _createBlock(_component_ag_signature_pad, {
                          key: 0,
                          empty: _ctx.isEmpty,
                          "onUpdate:empty": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isEmpty) = $event)),
                          position: "absolute",
                          opacity: _ctx.padClick ? 1 : 0,
                          "border-radius": "4px",
                          border: "1px solid #D9DEE8",
                          "line-max-width": 1,
                          height: "160px",
                          width: "335px",
                          bg: "bg1",
                          "line-color": "black",
                          onTouchstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                          onChange: _ctx.onChangeCanvas
                        }, null, 8, ["empty", "opacity", "onChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box, { "text-align": "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_button, {
                      block: "xs",
                      outline: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'본인 서명', 'clickContent':`다시 그리기`});_ctx.clearSign()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text, {
                  dp: "block",
                  p: "32px 0px 12px 0px",
                  typography: "main_16r"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.purchaseInfo.partnershipName) + " 및 (주)엔젤리그 귀중 ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          dp: "flex",
          p: "20px",
          mb: "safeAreaBottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              block: "lg",
              corner: "10px",
              width: "100%",
              disabled: !(_ctx.typoColor === 'primary' && _ctx.canvasRef && _ctx.readContract),
              onClickCapture: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`확인`});_ctx.signToJoin()})
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}